export function initialize(store) {
    axios.interceptors.response.use(null, (error) => {
    	if (error != null) {
	        if (error.response != null) {
		        if (error.response.status == 403) {
		            Vue.toasted.show('Acción no autorizada')
		        }
	        }
        }

        return Promise.reject(error)
    });
}